export default () => {
    const extensions = map => {
        return {
            getDefaultNodeText(node) {
                const _n = this.nodeProxy(node)
                return _n.defaultText()
            },

            getNodeText(node) {
                const _n = this.nodeProxy(node)
                return _n.getText()
            },

            getNodeTextPrefix(node) {
                const _n = this.nodeProxy(node)
                return _n.getTextPrefix()
            },

            getNodeTextSuffix(node) {
                const _n = this.nodeProxy(node)
                return _n.getTextSuffix()
            },

            getNodeTitle(node) {
                const _n = this.nodeProxy(node)
                return _n.getTitle()
            },
        }
    }

    return {extensions}
}
